import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import { toast } from "react-toastify";
import axios from "axios";
var BaseUrl = process.env.REACT_APP_BASEURL;

const AppHost = (props) => {
  const { aprrovedHost } = useContext(global);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [getHostByStatus1, setGetHostByStatus1] = useState([]);
  const [currentUsers, setCurrentUsers] = useState();
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  // Fetch hosts by status and page
  const indexOfLastUser = currentPage * entriesPerPage;
  const indexOfFirstUser = indexOfLastUser - entriesPerPage;
  const fetchHostsByStatus = async (status, page) => {
    try {
      let data = await fetch(
        `${BaseUrl}/agency/host/gethost?status=${status}&page=${page}&limit=${entriesPerPage}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let res = await data.json();
      setTotalPages(res.pages);
      setGetHostByStatus1(res.details);
      setCurrentUsers(res.details);
    } catch (err) {
      toast.error(err.message);
    }
  };

  // useEffect(() => {
  //   fetchHostsByStatus(props.status, currentPage);
  // }, [props.status]);
  useEffect(() => {
    fetchHostsByStatus(props.status, currentPage);
  }, [props.status]);

  // Logic to paginate the users

  // Change page
  const paginate = async (pageNumber) => {
    setCurrentPage(pageNumber);
    await fetchHostsByStatus(props.status, pageNumber);
  };

  // Pagination
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button onClick={() => paginate(i)} className="page-link">
            {i}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  const searhUser = async () => {
    try {
      // setSearchData(filterValue);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASEURL1}/admin/withdrawal/search?search=${search}&status=${props.status}&page=${currentPage}`
      );
      console.log(data.details);
      // setSearchData(data.details);
      setCurrentUsers(data.details);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    searhUser();
  }, [search]);
  return (
    <>
      <section className="content-header">
        <h1>Host List</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Host List</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <div className="row " style={{ padding: "16px 0px" }}>
                  <div className="entries-per-page col-md-6 ">
                    <label htmlFor="entries">Entries per page:</label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={(e) =>
                        setEntriesPerPage(parseInt(e.target.value))
                      }
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div
                    class="col-md-5"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      class="main-data-single-field"
                      style={{ width: "fit-content" }}
                    >
                      <span style={{ fontWeight: "bold", marginRight: "8px" }}>
                        Search
                      </span>
                      <span>
                        <input
                          type="text"
                          id="pname"
                          name="pname"
                          style={{
                            borderRadius: "4px",
                            borderStyle: "groove",
                            width: "150px",
                          }}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          placeholder="Searh User"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <table
                  id="example1"
                  className="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Username</th>
                      <th>Real name</th>
                      <th>Phone</th>
                      <th>Agency Code</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="ts">
                    {Array.isArray(searchData) && searchData.length > 0
                      ? searchData
                      : Array.isArray(currentUsers) &&
                        currentUsers.map((item, index) => {
                          let i = indexOfFirstUser + index + 1;
                          return (
                            <tr>
                              <td>{i}</td>
                              <td>{item?.username}</td>
                              <td>{item?.realName}</td>
                              <td>{item?.number}</td>
                              <td>{item?.agencyCode}</td>
                              <td>
                                {item.status == "0" ? (
                                  <td>
                                    <span className="label label-info">
                                      Pending
                                    </span>
                                  </td>
                                ) : item.status == 1 ? (
                                  <td>
                                    <span className="label label-success">
                                      Approved
                                    </span>
                                  </td>
                                ) : (
                                  <td>
                                    <span className="label label-danger">
                                      Rejected
                                    </span>
                                  </td>
                                )}
                              </td>
                              <td>
                                <ul
                                  className="admin-action btn btn-default"
                                  style={{
                                    backgroundColor: "#f4f4f4",
                                    color: "#fff !important",
                                  }}
                                >
                                  <li className="dropdown">
                                    <a
                                      className="dropdown-toggle"
                                      style={{ color: "black" }}
                                      data-toggle="dropdown"
                                      href="#"
                                      aria-expanded="false"
                                    >
                                      Action <span className="caret" />
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                      {item.status == 0 ? (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              aprrovedHost({
                                                id: item._id,
                                                status: "1",
                                              });
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Approve
                                            </Link>
                                          </li>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              aprrovedHost({
                                                id: item._id,
                                                status: "2",
                                              });
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : item.status == 1 ? (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              aprrovedHost({
                                                id: item._id,
                                                status: "2",
                                              });
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              aprrovedHost({
                                                id: item._id,
                                                status: "1",
                                              });
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Approve
                                            </Link>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          );
                        })}

                    {/* Repeat this row structure for each data item */}
                  </tbody>
                </table>
                {/* Pagination links */}

                <div className="row">
                  {/* Pagination */}

                  <div className="col-md-5">
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          onClick={() => paginate(currentPage - 1)}
                          className="page-link dfsdfasdf"
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {currentPage > 2 && (
                        <li className="page-item disabled"></li>
                      )}
                      {renderPageNumbers()}
                      {currentPage < totalPages - 1 && (
                        <li className="page-item disabled"></li>
                      )}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          onClick={() => paginate(currentPage + 1)}
                          className="page-link dfsdfasdf"
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-5">
                    <div
                      className="total-entries"
                      style={{ float: "right", marginTop: "20px" }}
                    >
                      Total entries: <b>{totalPages * entriesPerPage}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AppHost;
